import React from "react";
import { Modal, Button, Input, Select, InputNumber } from "antd";

const { Option } = Select;

const MachineModal = ({
  isModalOpen,
  handleCloseModal,
  newMachine,
  setNewMachine,
  errors,
  handleSave,
  departments,
  isEditMode,
}) => {
  return (
    <Modal
      title={isEditMode ? "Makine Güncelle" : "Makine Ekle"}
      visible={isModalOpen}
      onCancel={handleCloseModal}
      footer={null}
    >
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="Makine Adı"
          value={newMachine.name}
          onChange={(e) =>
            setNewMachine({ ...newMachine, name: e.target.value })
          }
        />
        {errors.name && <small className="text-red-500">{errors.name}</small>}
        <Input
          placeholder="Makine Kodu"
          value={newMachine.code}
          onChange={(e) =>
            setNewMachine({ ...newMachine, code: e.target.value })
          }
        />
        {errors.code && <small className="text-red-500">{errors.code}</small>}
        <Select
          placeholder="Makine Durumu"
          value={newMachine.status}
          onChange={(value) => setNewMachine({ ...newMachine, status: value })}
          className="col-span-2"
        >
          {errors.status && (
            <small className="text-red-500">{errors.status}</small>
          )}
          <Option value="active">Aktif</Option>
          <Option value="inactive">Pasif</Option>
          <Option value="maintenance">Bakımda</Option>
        </Select>
        <Input
          placeholder="Lokasyon"
          value={newMachine.location}
          onChange={(e) =>
            setNewMachine({ ...newMachine, location: e.target.value })
          }
        />
        {errors.location && (
          <small className="text-red-500">{errors.location}</small>
        )}
        <Select
          placeholder="Makine Tipi"
          value={newMachine.type}
          onChange={(value) => setNewMachine({ ...newMachine, type: value })}
        >
          {errors.type && <small className="text-red-500">{errors.type}</small>}
          <Option value="production">Production</Option>
          <Option value="assembly">Assembly</Option>
          <Option value="quality">Quality</Option>
        </Select>
        <InputNumber
          placeholder="Efficiency"
          value={newMachine.efficiency}
          min={0}
          max={100}
          onChange={(value) =>
            setNewMachine({ ...newMachine, efficiency: value })
          }
        />
        {errors.efficiency && (
          <small className="text-red-500">{errors.efficiency}</small>
        )}
        <InputNumber
          placeholder="Makine Yılı"
          value={newMachine.machineYear}
          min={1900}
          max={new Date().getFullYear()}
          onChange={(value) =>
            setNewMachine({ ...newMachine, machineYear: value })
          }
        />
        {errors.machineYear && (
          <small className="text-red-500">{errors.machineYear}</small>
        )}
        <Select
        value={newMachine.department}
          showSearch
          placeholder="Department Seçiniz"
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={departments.map((department) => ({
            value: department._id,
            label: department.name,
          }))}
          onChange={(value) =>
            setNewMachine({ ...newMachine, department: value })
          }
        />
        {errors.department && (
          <small className="text-red-500">{errors.department}</small>
        )}
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button
          onClick={handleCloseModal}
          className="bg-red-500 text-white hover:bg-red-600"
        >
          İptal
        </Button>
        <Button
          type="primary"
          onClick={handleSave}
          className="bg-black text-white hover:bg-gray-800"
        >
          {isEditMode ? "Güncelle" : "Ekle"}
        </Button>
      </div>
    </Modal>
  );
};

export default MachineModal;
